import React from "react";
import { useParams, Link } from "react-router-dom";
import useSWR from "swr";
import "../assets/css/ProjectDetails.css";
//import { useNavigate } from "react-router-dom";
import ModalImage from "react-modal-image";
const apiUrl = process.env.REACT_APP_BACKEND_URL;
const PRODUCTION_URL = process.env.REACT_APP_PRODUCTION_FRONTEND;
const apiToken = process.env.REACT_APP_API_TOKEN;

const fetcher = (url) =>
  fetch(url, {
    headers: {
      "x-api-key": apiToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error("Project niet gevonden");
    }
    return res.json();
  });

const ProjectDetails = () => {
//  const navigate = useNavigate();
  const { id } = useParams();
  const {
    data: projectenData,
    error: projectenError,
    loading: projectenIsLoading,
  } = useSWR(`${apiUrl}projecten`, fetcher, {
    errorRetryCount: 5,
    errorRetryInterval: 3000,
    shouldRetryOnError: true,
  });

  const { data, error, isLoading } = useSWR(
    id ? `${apiUrl}projecten/${id}` : null,
    fetcher,
    {
      errorRetryCount: 5,
      errorRetryInterval: 3000,
      shouldRetryOnError: true,
    }
  );
/*
  const HandleRightClick = () => {
    if (!projectenData || projectenData.items.length <= 1) return;

    const currentIndex = projectenData.items.findIndex(
      (p) => String(p.id) === String(id)
    );

    if (currentIndex === -1) return;

    const nextProject = projectenData.items[currentIndex + 1];

    if (!nextProject) return;

    navigate(`/project/${nextProject.id}`);
  };
  const HandleLeftClick = () => {
    if (!projectenData || projectenData.items.length <= 1) return;
    const currentIndex = projectenData.items.findIndex(
      (p) => String(p.id) === String(id)
    );

    if (currentIndex === -1) return;

    const nextProject = projectenData.items[currentIndex - 1];
    if (!nextProject) return;
    navigate(`/project/${nextProject.id}`);
  };
  const hasLeft = () => {
    if (!projectenData || projectenData.items.length <= 1) return false;
    const currentIndex = projectenData.items.findIndex(
      (p) => String(p.id) === String(id)
    );

    if (currentIndex === -1) return false;

    const nextProject = projectenData.items[currentIndex - 1];
    if (!nextProject) return false;
    return true;
  };
  const hasRight = () => {
    if (!projectenData || projectenData.items.length <= 1) return false;
    const currentIndex = projectenData.items.findIndex(
      (p) => String(p.id) === String(id)
    );

    if (currentIndex === -1) return false;

    const nextProject = projectenData.items[currentIndex + 1];
    if (!nextProject) return false;
    return true;
  };
*/
  if (isLoading || projectenIsLoading) {
    return <div className="project-details">Laden...</div>;
  }
  if (error || projectenError) {
    return (
      <div className="notfound">
        <h2>Project niet gevonden</h2>
        <Link to="/" className="back-btn">
          Terug naar home
        </Link>
      </div>
    );
  }

  if (!data || !projectenData) return null;

  const project = data;

  const mainPhoto = project.photos?.[0];
  const otherPhotos = project.photos?.slice(1) ?? [];
  return (
    <div className="project-details" style={{ marginTop: "8em" }}>
      {/* TOP GRID */}
      <div className="main-section">
        {/* Q2 — IMAGE */}
        {mainPhoto && (
          <img
            src={`${PRODUCTION_URL}${mainPhoto.path}`}
            alt={mainPhoto.name}
            className="main-image"
          />
        )}

        {/* Q1 — INFO */}
        <div className="project-info">
          <h1>{project.naam}</h1>

          <div className="project-meta">
            <p>
              <strong>Klant:</strong> {project.klant}
            </p>
            <p>
              <strong>Sector:</strong> {project.sector}
            </p>
            <p>
              <strong>Locatie:</strong> {project.locatie}
            </p>
            <p>
              <strong>Realisatie:</strong> {project.realisatie}
            </p>
          </div>
         { /*<div className="project-navigation">
            <button onClick={HandleLeftClick} className={()=>hasLeft() ? "arrow" : "arrow disabled"}>
              ←
            </button>
            <button onClick={HandleRightClick} className={()=>hasRight() ? "arrow" : "arrow disabled"}>
              →
            </button>
          </div>*/}
          {project.description && (
            <p className="project-description">{project.description}</p>
          )}
        </div>
      </div>

      {/* BOTTOM — Q3 / Q4 */}
      {otherPhotos.length > 0 && (
        <div className="collage">
          {otherPhotos.map((photo) => (
            <ModalImage
              key={photo.id}
              small={`${PRODUCTION_URL}${photo.path}`}
              medium={`${PRODUCTION_URL}${photo.path}`}
              alt={photo.name}
              className="collage-img"
              hideDownload={true}
              hideZoom={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
